import styled from '@emotion/styled'

import {
  mobile
} from '../../../utils/mixins'


export const MainContainer = styled.section`
  background-image: url('https://s3-ap-southeast-1.amazonaws.com/ibhubs-media-files/internships-bg.png');
  ${tw`bg-cover w-full h-320 bg-center  bg-light-navy flex flex-row items-center justify-center`}

  ${mobile} {
    ${tw`h-250`}
    background-position-x: center;
  }
`

export const CoverPageContainer = styled.div`
  ${tw` flex flex-col items-center justify-center pt-93 `}

  ${mobile} {
    ${tw` py-0 px-15 pt-97`}
  }
`

export const SubHeading = styled('p')`
  ${tw`m-0 mb-10 leading-1.33 tracking--1.4 text-center`}
  font-size: 36px;
  font-family: roboto;
  font-weight: 300;
  color:white;

  ${mobile} {
    ${tw`text-30`}
  }
`
